import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';
import useReveal from '../hooks/useReveal';

const Layout = () => {
  const { pathname } = useLocation();
  // Global scroll-reveal: adds `.in` to every `.reveal` node; re-scans per route.
  useReveal(pathname);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default Layout;
